import { defineAttrs as t } from "../../utils/typed-attrs.js";
const e = t({
  type: { default: "ifElseStatement" },
  fallbackBlocks: {},
  predicatesBlocksPairs: {}
}), s = {
  content: "",
  group: "block",
  marks: "",
  atom: !0,
  attrs: e,
  toDOM() {
    return ["div"];
  }
};
export {
  s as ifElseStatementSpec
};
